import { useEffect, useState } from 'react'

/**
 * The Bubble Chart's custom hook.
 */
const useBubbleChart = detail => {
  const [serie, setSerie] = useState([])
  const [ranges, setRanges] = useState({})
  const months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ]
  const base = [
    { x: 0 },
    { x: 1 },
    { x: 2 },
    { x: 3 },
    { x: 4 },
    { x: 5 },
    { x: 6 },
    { x: 7 },
    { x: 8 },
    { x: 9 },
    { x: 10 },
    { x: 11 }
  ]

  useEffect(() => {
    const setData = () => {
      const data = detail.map(item => ({
        x: item.numberMonth - 1,
        y: item.grossAmountCLP,
        z: item.numberPO,
        name: item.provider
      }))

      let minRange, maxRange

      if (detail.length > 1) {
        minRange = detail.reduce((a, b) => {
          return a.numberPO < b.numberPO ? a.numberPO : b.numberPO
        })
        maxRange = detail.reduce((a, b) => {
          return a.numberPO > b.numberPO ? a.numberPO : b.numberPO
        })
      } else {
        minRange = detail.reduce((a, b) => {
          return a.numberPO < b.numberPO ? a.numberPO : b.numberPO
        }, 0)
        maxRange = detail.reduce((a, b) => {
          return a.numberPO > b.numberPO ? a.numberPO : b.numberPO
        }, 0)
      }
      setRanges({ min: minRange * 5 > 10 ? 10 : minRange * 5, max: maxRange * 6 > 45 ? 45 : maxRange * 6 })

      const clearBase = base.filter(item => !data.some(item2 => item2.x === item.x))
      const clearData = data.filter(item => base.some(item2 => item2.x === item.x))
      setSerie([...clearBase, ...clearData])
    }
    setData()
  }, [detail])

  return { serie, months, ranges }
}

export default useBubbleChart
